var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthcare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28.561,
    viewBox: "0 0 30 28.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -11.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.964,27.512A3.5,3.5,0,0,0,27,24.548v-.909a4.413,4.413,0,0,0-4.25-4.55A4.43,4.43,0,0,0,18.5,23.5h.029l-.029,0v9.853a5.5,5.5,0,0,1-5.25,5.708A5.5,5.5,0,0,1,8,33.362v-.853c.725,0,1.5-.525,1.5-2V29.251a7.091,7.091,0,0,0,5.5-6.7V21.508H14L13.979,15a2.5,2.5,0,0,0-2.057-2.447,1.492,1.492,0,1,0-.034,1.019A1.5,1.5,0,0,1,12.977,15l.023,6.5H12v1.057A3.976,3.976,0,0,1,9.122,26.3a4.546,4.546,0,0,1-2.75,0A3.974,3.974,0,0,1,3.5,22.565V21.508H2v-6.5a1.5,1.5,0,0,1,1.11-1.442,1.507,1.507,0,1,0-.031-1.015A2.5,2.5,0,0,0,1,15.008v6.5H0v1.04a7.09,7.09,0,0,0,5.5,6.7v1.257c0,1.474.775,2,1.5,2v.853a6.5,6.5,0,0,0,6.25,6.708,6.5,6.5,0,0,0,6.25-6.708V23.532a3.422,3.422,0,0,1,3.25-3.441A3.413,3.413,0,0,1,26,23.641v.907a3.5,3.5,0,1,0,3.964,2.964Zm-19.464-14a.5.5,0,1,1,.5-.5A.5.5,0,0,1,10.5,13.508Zm-6-1a.5.5,0,1,1-.5.5A.5.5,0,0,1,4.5,12.508ZM1,22.548v-.04H2.5v.057a4.968,4.968,0,0,0,3.569,4.681,5.564,5.564,0,0,0,3.359,0A4.969,4.969,0,0,0,13,22.565v-.057h1v.04a6.129,6.129,0,0,1-5.1,5.821,7.132,7.132,0,0,1-2.109.1,6.53,6.53,0,0,1-.69-.1A6.127,6.127,0,0,1,1,22.548Zm6,8.96c-.45,0-.5-.7-.5-1V29.447c.04,0,.081.007.121.011l.15.014c.236.021.475.035.715.035h.025c.24,0,.478-.015.713-.035l.154-.014c.039,0,.08-.006.12-.011v1.061c0,.3-.05,1-.5,1Zm19.5-1a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,26.5,30.508Z",
    transform: "translate(0 -11.508)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 26.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.5,251.515a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,401.5,251.515Zm0,2a.5.5,0,1,1,.5-.5A.5.5,0,0,1,401.5,253.515Z",
    transform: "translate(-400 -251.515)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.b72bf7e4.svg";
export { ForwardRef as ReactComponent };